import { Poller } from '@as-react/common-utils';
import { GLOSSARY_KEY } from '../constants/GeneralConstants';
import { useEffect, useState } from 'react';
const GLOSSARY_POLL_INTERVAL = 500;
export const useInitGlossaryTooltips = () => {
    const [isGlossaryLoaded, setIsGlossaryLoaded] = useState(false);
    const [shouldInitGlossaryTooltips, setShouldInitGlossaryTooltips] = useState(false);
    useEffect(() => {
        const glossaryPoll = new Poller(() => {
            if (window === null || window === void 0 ? void 0 : window[GLOSSARY_KEY]) {
                return true;
            }
            return false;
        }, GLOSSARY_POLL_INTERVAL);
        if (window === null || window === void 0 ? void 0 : window[GLOSSARY_KEY]) {
            setIsGlossaryLoaded(true);
            setShouldInitGlossaryTooltips(true); // need to init glossary tooltips, because this component was initialized after the glossary initialization
        }
        else {
            glossaryPoll.run().then(() => setIsGlossaryLoaded(true));
        }
        return () => glossaryPoll.end();
    }, []);
    return {
        isGlossaryLoaded,
        shouldInitGlossaryTooltips,
    };
};
